<template>
  <div>
    <ul class="tabs">
      <li class="tab1_1">
        <a href="javascript:;" @click="changeTab('1')" :class="[curTab == '1' ? 'current': '']">正在学习（{{learningCnt}}）</a>
      </li>
      <li class="tab1_2">
        <a href="javascript:;" @click="changeTab('2')" :class="[curTab == '2' ? 'current': '']">已完成（{{learnedCnt}}）</a>
      </li>
    </ul>
    <div class="tab_content jilu">
      <!--正在学习-->
      <div v-if="curTab=='1'"  class="wrap">
        <h5 class="none_ts" v-if="courseList_doing.length == 0" style="text-align: center;">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
        <dl v-for="item in courseList_doing" :key="item.id">
          <dt>
            <!--<i>机构名称上海仪电</i>-->
            <p>
              <img v-if="item.faceUrl" :src="item.faceUrl" />
              <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/class_img.jpg" />
            </p>
            <h3>
              {{item.name}}<br />
              <span>{{item.classifiName}}</span>
            </h3>
            <p class="con_txt" v-html="item.introduction"></p>
          </dt>
          <dd>
            <span v-if="item.collect" @click="course_collectOrCancel(item.id, $event, '1')">已收藏</span>
            <span v-if="!item.collect" @click="course_collectOrCancel(item.id, $event, '1')" class="focus">收藏</span>
            <a href="javascript:;" @click="course_detail(item.id)">继续学习</a>
          </dd>
        </dl>
      </div>
      <!--/正在学习-->
      <!--已完成-->
      <div v-if="curTab=='2'"  class="wrap js_con">
        <h5 class="none_ts" v-if="courseList_done.length == 0" style="text-align: center;">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
        <dl v-for="item in courseList_done" :key="item.id">
          <dt>
            <!--<i>机构名称上海仪电</i>-->
            <p>
              <img v-if="item.faceUrl" :src="item.faceUrl" />
              <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/class_img.jpg" />
            </p>
            <h3>
              {{item.name}}<br />
              <span>{{item.classifiName}}</span>
            </h3>
            <p class="con_txt" v-html="item.introduction"></p>
          </dt>
          <dd>
            <span v-if="item.collect" @click="course_collectOrCancel(item.id, $event, '2')">已收藏</span>
            <span v-if="!item.collect" @click="course_collectOrCancel(item.id, $event, '2')" class="focus">收藏</span>
            <a href="javascript:;" @click="course_detail(item.id)">继续学习</a>
          </dd>
        </dl>
      </div>
      <!--/已完成-->
    </div>
    <div class="zy_list_bottom" v-if="courseList_doing.length > 0 && curTab=='1'" style="padding-top:0">
      <div>
        <div>
          <paginate :click-handler="clickCallback1" :page-count=pages1
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </div>
      </div>
    </div>
    <div class="zy_list_bottom" v-if="courseList_done.length > 0 && curTab=='2'" style="padding-top:0">
      <div>
        <div>
          <paginate :click-handler="clickCallback2" :page-count=pages2
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {init} from '@/assets/js/public_mem'
import { getCookie } from '@/store/cookies'
import Paginate from 'vuejs-paginate'
export default {
  components: { Paginate },
  data () {
    return {
      filter1: {
        pageNo: 1,
        pageSize: 4,
        status: '1'
      },
      filter2: {
        pageNo: 1,
        pageSize: 4,
        status: '2'
      },
      pages1: 0,
      pages2: 0,
      courseList_doing: [],
      courseList_done: [],
      learnedCnt: 0,
      learningCnt: 0,
      curTab: '1'
    }
  },
  created () {
    this.getUserCourses_Doing(this.filter1)
    this.getUserCourses_Done(this.filter2)
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  methods: {
    clickCallback1 (pageNum) {
      this.filter1.pageNo = pageNum
      this.getUserCourses_Doing(this.filter1)
    },
    clickCallback2 (pageNum) {
      this.filter2.pageNo = pageNum
      this.getUserCourses_Done(this.filter2)
    },
    changeTab (tabIndex) {
      if (tabIndex != this.curTab) {
        this.curTab = tabIndex
      }
    },
    getUserCourses_Doing (filter) {
      this.$api.post(this.$global.courseApiPath, '/course/learn/list', filter, r => {
        if (r.data && r.data.length>0) {
          this.learningCnt = r.cntData
          this.courseList_doing = r.data
          this.pages1 = Math.ceil(r.cntData / this.filter1.pageSize)
        } else {
          this.courseList_doing = []
          this.pages1 = 0
        }
      })
    },
    getUserCourses_Done (filter) {
      this.$api.post(this.$global.courseApiPath, '/course/learn/list', filter, r => {
        if (r.data && r.data.length>0) {
          this.learnedCnt = r.cntData
          this.courseList_done = r.data
          this.pages2 = Math.ceil(r.cntData / this.filter2.pageSize)
        } else {
          this.courseList_done = []
          this.pages2 = 0
        }
      })
    },
    course_detail (id) {
      var path = this.$OR.getUrl(getCookie('org').businessId)
      this.$router.push({
        path: path + '/courseDetail/' + id
      })
    },
    course_collectOrCancel (courseId, event, type) {
      if (this.$TOKEN_VAL && this.$TOKEN_VAL!='') {
        let curClass = $(event.target).attr('class')
        if (curClass == 'focus') {
          this.$api.post(this.$global.courseApiPath, '/course/collect', {courseId: courseId}, r => {
            this.$toasted.show('收藏成功！', {
              duration: 800
            })
            if (type == '1') {
              this.getUserCourses_Doing(this.filter1)
            } else if (type == '2') {
              this.getUserCourses_Done(this.filter2)
            }
          })
        } else if (curClass == '' || !curClass) {
          this.$api.post(this.$global.courseApiPath, '/course/collect/collects', {courseId: courseId, delFlag: '0'}, r => {
            if (r.data && r.data.length>0) {
              this.$api.getRestful(this.$global.courseApiPath, '/course/collect/delete/' + r.data[0].id, {}, r => {
                this.$toasted.show('取消收藏成功！', {
                  duration: 800
                })
                if (type == '1') {
                  this.getUserCourses_Doing(this.filter1)
                } else if (type == '2') {
                  this.getUserCourses_Done(this.filter2)
                }
              })
            }
          })
        }
      } else {
        this.$toasted.show('请先登录！', {
          duration: 800
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/record.vue